module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart-add":"Добавить график"},"en":{"chart-add":"Add new chart"}}')
  delete Component.options._Ctor
}
